export enum ProductUIMessages {
  LOAD_PRODUCT_ERROR = 'An error occurred while loading the product.',
  LOAD_LINES_OF_SERVICE_ERROR = 'An error occurred while loading the product lines of service.',
  LOAD_ASSET_ATTACHMENT_ERROR = 'An error occurred while loading the asset attachments.',
  LOAD_PRODUCT_LINES_ERROR = 'An error occurred while loading the product lines.',
  LOAD_PRODUCTS_SUPPLIED_BY_CUSTOMER_ERROR = 'An error occurred while loading the products supplied by a customer.',
  LOAD_PRODUCT_TYPES_ERROR = 'An error occurred while loading the product types.',
  LOAD_VENDORS_ERROR = 'An error occurred while loading the vendors.',
  LOAD_MAKES_ERROR = 'An error occurred while loading the Makes.',
  LOAD_PRODUCT_DETAIL_ERROR = 'An Error Occurred Getting Detail Product view.',
  ADD_PRODUCT_SUCCESS = 'Product successfully created.',
  ADD_PRODUCT_ERROR = 'An error ocurred while creating the product.',
  ADD_PRODUCT_LABOUR_INFO_LOS_ERROR = 'An error ocurred while creating the Product Labour Information or Lines of Services.',
  EDIT_PRODUCT_SUCCESS = 'Product ({0}) successfully edited.',
  EDIT_PRODUCT_ERROR = 'An error ocurred while editing the product ({0}).',
  EDIT_EWARRANTYDURATION_SUCCESS = 'Labor and parts duration successfully edited for the product ({0})',
  EDIT_EWARRANTYDURATION_ERROR = 'An error ocurred while editing the labor and parts Duration for the product ({0}).',
  EDIT_PRODUCT_LABOUR_INFO_ERROR = 'An error ocurred while editing the product ({0}) labour information.',
  EDIT_LINES_OF_SERVICE_SUCCESS = 'Lines of Service successfully updated.',
  EDIT_LINES_OF_SERVICE_ERROR = 'An error ocurred while saving the Lines of Service.',
  EDIT_PRODUCT_LINES_SUCCESS = 'Product Lines successfully updated.',
  EDIT_PRODUCTS_SUPPLIED_BY_CUSTOMER_SUCCESS = 'Products supplied by a customer successfully updated.',
  EDIT_PRODUCT_LINES_ERROR = 'An error ocurred while saving the Product Lines.',
  EDIT_PRODUCTS_SUPPLIED_BY_CUSTOMER_ERROR = 'An error ocurred while saving the Products supplied by a customer.',
  DEACTIVATE_PRODUCT_SUCCESS = 'Product successfully deactivated.',
  DEACTIVATE_PRODUCTS_SUCCESS = 'Product(s) successfully deactivated.',
  DEACTIVATE_PRODUCTS_ERROR = 'An error occurred while deactivating the products.',
  DEACTIVATE_PRODUCT_ERROR = 'An error occurred while deactivating the product.',
  ACTIVATE_PRODUCT_SUCCESS = 'Product successfully activated.',
  ACTIVATE_PRODUCT_ERROR = 'An error occurred while activating the product.',
  VALIDATION_PRODUCT_NAME_ERROR = 'An error ocurred while validating product ({0}) unique name.',
  SEARCH_PRODUCTS_ERROR = 'An error occurred while searching products.',
  EXPORT_PRODUCTS_SUCCESS = 'Exported file sucessfully generated.',
  EXPORT_PRODUCTS_ERROR = 'An error occurred while exporting products results.',
  VALIDATION_EXPORT_PRODUCTS_LIMIT_EXCEEDED = 'Too much results to export. Limit is {0}.',
  LOAD_KEYWORDS_ERROR = 'An error occurred while loading the keywords.',
  ADD_KEYWORD_SUCCESS = 'Keyword successfully created.',
  ADD_KEYWORD_ERROR = 'An error occurred while creating the Keyword.',
  EDIT_KEYWORD_SUCCESS = 'Keyword successfully edited.',
  EDIT_KEYWORD_ERROR = 'An error ocurred while editing the keyword.'
}
